module.exports = __webpack_public_path__ + "5b1bdb41563da36dac4ebf3909e9da35.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-25.png
// module id = 3071
// module chunks = 0